if (!customElements.get("gallery-zoom-open")) {
  class t extends HTMLElement {
    connectedCallback() {
      this.addEventListener("click", this.handleClick.bind(this));
    }
    handleClick(t) {
      let e = this.closest("media-gallery");
      e.galleryModal.parentElement || document.body.appendChild(e.galleryModal),
        e.galleryModal.open(t.currentTarget);
      let i = e.galleryModal.querySelector("gallery-zoom"),
        r = Array.from(i.querySelectorAll(".gallery-zoom__thumb"));
      e.querySelectorAll(".media-viewer__item").forEach((t) => {
        for (let e = 0; e < r.length; e += 1)
          r[e].dataset.mediaId === t.dataset.mediaId &&
            r[e].toggleAttribute("hidden", !!t.hidden);
      }),
        i.init(t.currentTarget.parentElement.dataset.mediaId),
        i.focus(),
        t.preventDefault();
    }
  }
  window.customElements.define("gallery-zoom-open", t);
}
if (!customElements.get("gallery-zoom")) {
  class e extends HTMLElement {
    connectedCallback() {
      this.initialised ||
        ((this.initialised = !0),
        this.classList.add("gallery-zoom--pre-reveal"),
        (this.zoomContainer = this.querySelector(
          ".gallery-zoom__zoom-container"
        )),
        (this.thumbContainer = this.querySelector(".gallery-zoom__thumbs")),
        (this.controlsContainer = this.querySelector(
          ".gallery-zoom__controls"
        )),
        (this.previousBtn = this.querySelector(".gallery-zoom__prev")),
        (this.nextBtn = this.querySelector(".gallery-zoom__next")),
        (this.wheelZoomMultiplier = -0.001),
        (this.pinchZoomMultiplier = 0.003),
        (this.touchPanModifier = 1),
        (this.currentZoomImage = null),
        (this.currentTransform = { panX: 0, panY: 0, zoom: 1 }),
        (this.pinchTracking = { isTracking: !1, lastPinchDistance: 0 }),
        (this.touchTracking = { isTracking: !1, lastTouchX: 0, lastTouchY: 0 }),
        this.querySelectorAll(".gallery-zoom__thumb").forEach((t) => {
          t.addEventListener("click", this.onThumbClick.bind(this));
        }),
        this.addEventListener("touchend", this.stopTrackingTouch.bind(this)),
        this.addEventListener("touchmove", this.trackInputMovement.bind(this)),
        this.addEventListener("mousemove", this.trackInputMovement.bind(this)),
        this.addEventListener("wheel", this.trackWheel.bind(this)),
        this.thumbContainer.addEventListener("touchmove", (t) =>
          t.stopPropagation()
        ),
        this.previousBtn.addEventListener(
          "click",
          this.selectPreviousThumb.bind(this)
        ),
        this.nextBtn.addEventListener("click", this.selectNextThumb.bind(this)),
        this.zoomContainer.addEventListener(
          "click",
          this.onZoomContainerClick.bind(this)
        ),
        new ResizeObserver(() => this.setInitialImagePosition()).observe(this)),
        document.documentElement.classList.add("gallery-zoom-open"),
        this.addEventListener("keyup", this.handleKeyup.bind(this)),
        setTimeout(() => this.classList.remove("gallery-zoom--pre-reveal"), 10);
    }
    disconnectedCallback() {
      document.documentElement.classList.remove("gallery-zoom-open");
    }
    static createEl(t, e, i, r) {
      let n = document.createElement(t);
      return (
        (n.className = e),
        i && i.insertAdjacentElement("beforeend", n),
        r && (n.innerHTML = r),
        n
      );
    }
    init(t) {
      this.selectThumb(
        [...this.thumbContainer.children].find(
          (e) => e.dataset.mediaId === t
        ) || this.thumbContainer.firstElementChild
      );
    }
    panZoomImageFromCoordinate(t, e) {
      let i = this.currentZoomImage.clientWidth > this.clientWidth,
        r = this.currentZoomImage.clientHeight > this.clientHeight;
      if (i || r) {
        let n = this.clientWidth / 2,
          o = this.clientHeight / 2,
          s = 0,
          a = 0;
        if (i) {
          let h =
            (this.currentZoomImage.clientWidth - this.clientWidth) / 2 / n;
          s = Math.round(-(t - n) * h);
        }
        if (r) {
          let l =
            (this.currentZoomImage.clientHeight - this.clientHeight) / 2 / o;
          a = Math.round(-(e - o) * l);
        }
        (this.currentTransform.panX = s),
          (this.currentTransform.panY = a),
          this.alterCurrentPanBy(0, 0),
          this.updateImagePosition();
      }
    }
    alterCurrentPanBy(t, e) {
      this.currentTransform.panX += t;
      let i =
        (this.currentZoomImage.naturalWidth * this.currentTransform.zoom -
          this.clientWidth) /
        2;
      (i = Math.max(i, 0)),
        (this.currentTransform.panX = Math.min(this.currentTransform.panX, i)),
        (this.currentTransform.panX = Math.max(this.currentTransform.panX, -i)),
        (this.currentTransform.panY += e);
      let r =
        (this.currentZoomImage.naturalHeight * this.currentTransform.zoom -
          this.clientHeight) /
        2;
      (r = Math.max(r, 0)),
        (this.currentTransform.panY = Math.min(this.currentTransform.panY, r)),
        (this.currentTransform.panY = Math.max(this.currentTransform.panY, -r)),
        this.updateImagePosition();
    }
    setCurrentTransform(t, e, i) {
      (this.currentTransform.panX = t),
        (this.currentTransform.panY = e),
        (this.currentTransform.zoom = i),
        this.alterCurrentTransformZoomBy(0);
    }
    alterCurrentTransformZoomBy(t) {
      this.currentTransform.zoom += t;
      let e = this.clientWidth / this.currentZoomImage.naturalWidth,
        i = this.clientHeight / this.currentZoomImage.naturalHeight;
      (this.currentTransform.zoom = Math.max(
        this.currentTransform.zoom,
        Math.min(e, i)
      )),
        (this.currentTransform.zoom = Math.min(this.currentTransform.zoom, 1)),
        this.alterCurrentPanBy(0, 0),
        this.updateImagePosition();
    }
    setInitialImagePosition() {
      (this.currentZoomImage.style.top = `${
        this.clientHeight / 2 - this.currentZoomImage.clientHeight / 2
      }px`),
        (this.currentZoomImage.style.left = `${
          this.clientWidth / 2 - this.currentZoomImage.clientWidth / 2
        }px`),
        this.setCurrentTransform(0, 0, 0);
    }
    updateImagePosition() {
      this.currentZoomImage.style.transform = `translate3d(${this.currentTransform.panX}px, ${this.currentTransform.panY}px, 0) scale(${this.currentTransform.zoom})`;
    }
    selectThumb(t) {
      [...t.parentElement.children].forEach((e) => {
        e === t
          ? e.classList.add("gallery-zoom__thumb--active")
          : e.classList.remove("gallery-zoom__thumb--active");
      }),
        this.zoomContainer.classList.add(
          "gallery-zoom__zoom-container--loading"
        ),
        (this.currentZoomImage = e.createEl("img", "gallery-zoom__zoom-image")),
        (this.currentZoomImage.alt = ""),
        (this.currentZoomImage.style.visibility = "hidden"),
        (this.currentZoomImage.onload = () => {
          this.zoomContainer.classList.remove(
            "gallery-zoom__zoom-container--loading"
          ),
            (this.currentZoomImage.style.visibility = ""),
            this.setInitialImagePosition();
        }),
        (this.currentZoomImage.src = t.dataset.zoomUrl),
        this.zoomContainer.replaceChildren(this.currentZoomImage);
    }
    selectPreviousThumb(t) {
      if ((t && t.preventDefault(), this.thumbContainer.childElementCount < 2))
        return;
      let e = this.thumbContainer.querySelector(
        ".gallery-zoom__thumb--active"
      ).previousElementSibling;
      for (; !e || !e.offsetParent; )
        e = e ? e.previousElementSibling : this.thumbContainer.lastElementChild;
      this.selectThumb(e);
    }
    selectNextThumb(t) {
      if ((t && t.preventDefault(), this.thumbContainer.childElementCount < 2))
        return;
      let e = this.thumbContainer.querySelector(
        ".gallery-zoom__thumb--active"
      ).nextElementSibling;
      for (; !e || !e.offsetParent; )
        e = e ? e.nextElementSibling : this.thumbContainer.firstElementChild;
      this.selectThumb(e);
    }
    stopTrackingTouch() {
      (this.pinchTracking.isTracking = !1),
        (this.touchTracking.isTracking = !1);
    }
    trackInputMovement(t) {
      if (
        (t.preventDefault(), "touchmove" === t.type && t.touches.length > 0)
      ) {
        let e = t.touches[0];
        if (
          (this.touchTracking.isTracking
            ? (this.alterCurrentPanBy(
                (e.clientX - this.touchTracking.lastTouchX) *
                  this.touchPanModifier,
                (e.clientY - this.touchTracking.lastTouchY) *
                  this.touchPanModifier
              ),
              (this.touchTracking.lastTouchX = e.clientX),
              (this.touchTracking.lastTouchY = e.clientY))
            : ((this.touchTracking.isTracking = !0),
              (this.touchTracking.lastTouchX = e.clientX),
              (this.touchTracking.lastTouchY = e.clientY)),
          2 === t.touches.length)
        ) {
          let i = t.touches[1],
            r = Math.sqrt(
              (e.clientX - i.clientX) ** 2 + (e.clientY - i.clientY) ** 2
            );
          if (this.pinchTracking.isTracking) {
            let n = r - this.pinchTracking.lastPinchDistance;
            this.alterCurrentTransformZoomBy(n * this.pinchZoomMultiplier),
              (this.pinchTracking.lastPinchDistance = r);
          } else
            (this.pinchTracking.lastPinchDistance = r),
              (this.pinchTracking.isTracking = !0);
        } else this.pinchTracking.isTracking = !1;
      } else this.panZoomImageFromCoordinate(t.clientX, t.clientY);
    }
    trackWheel(t) {
      t.preventDefault(),
        0 !== t.deltaY &&
          this.alterCurrentTransformZoomBy(t.deltaY * this.wheelZoomMultiplier);
    }
    onThumbClick(t) {
      t.preventDefault(), this.selectThumb(t.currentTarget);
    }
    onZoomContainerClick(t) {
      t.preventDefault(),
        1 === this.currentTransform.zoom
          ? ((this.currentTransform.zoom = 0),
            this.alterCurrentTransformZoomBy(0))
          : ((this.currentTransform.zoom = 1),
            this.alterCurrentTransformZoomBy(0),
            this.panZoomImageFromCoordinate(t.clientX, t.clientY));
    }
    handleKeyup(t) {
      switch (t.key) {
        case "ArrowLeft":
          t.preventDefault(), this.selectPreviousThumb();
          break;
        case "ArrowRight":
          t.preventDefault(), this.selectNextThumb();
      }
    }
  }
  window.customElements.define("gallery-zoom", e);
}
